import React from 'react';
import { AppFeatureName } from '@xarvio/frontend-core-state/lib/featureFlags/utils';
import { useIsFeatureEnabled } from '@xarvio/frontend-core-state/lib/featureFlags/useIsFeatureEnabled';

export interface FeatureToggleProps {
  featureName: AppFeatureName;
}

export const FeatureToggle: React.FC<
  React.PropsWithChildren<FeatureToggleProps>
> = ({ featureName, children }) => {
  const enabled = useIsFeatureEnabled(featureName);
  return <>{enabled ? children : null}</>;
};
